import React from "react";
import clsx from "clsx";

import {mergeClasses} from "@material-ui/styles";

import CheckboxFormElement from "../../../../formElement/CheckboxFormElement/CheckboxFormElement";
import {withStyles} from "@material-ui/core/styles";

import styles from "./styles";


const CheckboxCard = props => {
  const {
    classes,
    value,
    onChange,
    disabled,
    label,
    name,
    required,
    error,
    helpText,
    custom_classes,
  } = props;

  return (
    <div className={clsx(classes.checkboxQuestionContainer, value && 'checked')} onClick={onChange}>
      <CheckboxFormElement
        disabled={disabled || false}
        value={value}
        label={label}
        name={name}
        required={required}
        custom_classes={
          mergeClasses({
            baseClasses: {root: 'newDesign', label: 'newDesign', radio: 'newDesign'},
            newClasses: custom_classes,
            Component: CheckboxFormElement
          })
        }
        error={error}
        helpTextUsed={!!helpText}
      />
      {helpText && <div className={classes.helpText}>{helpText}</div>}
    </div>
  )
};

export default withStyles(styles)(CheckboxCard);